import { useState } from 'react';
import { ThuChi, ThuChiParentData } from '@/types/schemas';

export interface FormState {
  parent: ThuChi | ThuChiParentData | null;
}

export interface FormActions {
  setParent: (parent: ThuChi) => void;
  resetState: () => void;
  updateState: (updates: Partial<FormState>) => void;
}

export interface UseFormStateReturn {
  state: FormState;
  actions: FormActions;
}

const initialState: FormState = {
  parent: null
};

function transformInitialData(initialData?: ThuChi): Partial<FormState> {
  if (!initialData) return {};

  return {
    parent: initialData.ma_cha_data || null
  };
}

export function useFormState(initialData?: ThuChi): UseFormStateReturn {
  const [state, setState] = useState<FormState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: FormActions = {
    setParent: (parent: ThuChi) => {
      setState(prev => ({ ...prev, parent }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<FormState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
